import { createEnvelopeSource } from './create-envelope-source';
import type { EnvelopeSourceConfig } from './create-envelope-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type SegmentMetric =
    | 'activeMembers'
    | 'shareOfCampaign'
    | 'couponRedemptionRate'
    | 'memberRedemptionRate';

/** One customer group of the campaign, narrowed by the request's `segment`
 * (see `KpiSegment`), which the endpoint requires and answers 400 without.
 *
 * Neither campaign wrapper is composed in: the endpoint serves one period
 * window and declares no compare, so its cards read `number` and `rate`
 * rather than the two campaign trio forms. */
const config: EnvelopeSourceConfig<SegmentMetric> = {
    label: 'Campaign customer group',
    endpoint: 'analytics/campaign-segment-member',
    metrics: [
        { id: 'activeMembers', label: 'Active members', type: 'scalar' },
        { id: 'shareOfCampaign', label: 'Share of campaign', type: 'ratio' },
        {
            id: 'couponRedemptionRate',
            label: 'Coupon redemption rate',
            type: 'ratio',
        },
        {
            id: 'memberRedemptionRate',
            label: 'Member redemption rate',
            type: 'ratio',
        },
    ],
    forms: ['number', 'rate'],
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
};

export const campaignSegmentMemberSource = createEnvelopeSource(config);
